// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__flZCw","danger":"IconButton_danger__eRIfV","primary":"IconButton_primary__tKauF","neutral":"IconButton_neutral__2XI61","label":"IconButton_label__Q2tKr"};